<template>
    <div class="banned_people">
        <h2 class="subheading grey--text">{{$t('banned_people')}}</h2>
        <v-dialog v-model="dialog_elimnar" max-width="290">
                <v-card>
                    <v-card-title class="headline">
                        {{$t('msg_eliminar_ban')}}
                    </v-card-title>
                    <v-card-text>
                        {{$t('msg_eliminar_invitacion_2')}}
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialog_elimnar = false"
                        >
                            No
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                :loading="loading"
                                @click="eliminar_veto()"
                        >
                            {{$t('Si')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        <v-container class="my-5">
            <v-layout align-center justify-center fill-height>
                <v-dialog v-model="dialog" max-width="400px">
                        <v-card class="elevation-5">
                            <v-card-text>
                                <v-textarea
                                        v-model="nombre"
                                        prepend-icon="message"
                                        name="nombre"
                                        :label="$t('reason')"
                                >
                                </v-textarea>
                            </v-card-text>
                        </v-card>
                </v-dialog>
            </v-layout>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('banned_people')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_vetos"
                            :items="vetos"
                            :search="search"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :rows-per-page-items="[
                            {text: this.$t('todos'),
                            value: -1}]"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                        medium
                                        v-on="on"
                                        @click="dialog = true, fill_fields(props.item)"
                                    >
                                      message
                                    </v-icon>
                                  </template>
                                  <span>{{$t('show_reasons')}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                        medium
                                        v-on="on"
                                        color="red"
                                        @click="dialog_elimnar = true, id_veto_eliminar = props.item.id"
                                    >
                                      delete
                                    </v-icon>
                                  </template>
                                  <span>{{$t('remove_ban')}}</span>
                                </v-tooltip>
                            </td>
                            <td class="center">{{ props.item.user_full_name }}</td>
                            <td>{{ props.item.tipo === 1 ? $t('period2') : $t('undefined') }}</td>
                            <td>{{ props.item.tipo === 1 ? props.item.fecha_inicial : '-' }}</td>
                            <td>{{ props.item.tipo === 1 ? props.item.fecha_final : '-' }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('banned_people')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import { mapState, mapGetters } from 'vuex'
    Vue.use(VeeValidate)

    export default {
        name: "banned_people",
        data: () => ({
            dialog: false,
            nombre: '',
            search: '',
            vetos: [],
            headers: [],
            loading_data_vetos: false,
            loading: false,
            dialog_elimnar: false,
        }),
        beforeUpdate(){
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'user_full_name'
                },
                {
                    text: this.$t('type_ban'),
                    align: 'left',
                    sortable: true,
                    value: 'tipo'
                },
                {
                    text: this.$t('Fecha_ini'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_inicial'
                },
                {
                    text: this.$t('Fecha_fin'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_final'
                }
            ]
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile'])
        },
        created: function(){
            this.get_vetos()
        },
        methods: {
            get_vetos: function(){
              this.loading_data_vetos = true
              const config = {
                  method: 'get',
                  url: 'https://empresa-service.intrare.app/empresas/vetos/',
                  headers: {
                      'Content-Type': 'application/json',
                      'authorization': 'Token ' + store.getters.getToken
                  }
              };
              axios(config)
                  .then(response => {
                      this.vetos = response.data
                      this.loading_data_vetos = false
                  })
                  .catch(error => {
                      this.loading_data_vetos = false
                      console.log(error)
                  })
            },
            eliminar_veto(){
                this.loading = true
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/empresas/vetos/Detail&Update&Delete/' + this.id_veto_eliminar + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                };
                axios(config).then(ok => {
                    this.loading = false
                    console.log('Veto con ID  = ', this.id_veto_eliminar + ' eliminado Correctamente.')
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', this.$t('veto_removed_successfully'))
                    this.get_vetos()
                    setTimeout(this.clear, 3000);
                    this.dialog_elimnar = false
                })
                .catch(error => {
                  this.loading = false
                  console.log(error)
                })
            },
            fill_fields(item){
                this.nombre = item.motivo
            },
            clear () {
                this.$store.commit('snackbar_activate_false')
            }
        }
    }
</script>

<style scoped>

</style>
